/**
 * IconaWhatsApp — il simbolo di WhatsApp, disegnato qui.
 *
 * PERCHE' NON ARRIVA DALLA LIBRERIA DELLE ICONE
 * Lucide, che disegna tutte le altre icone del gestionale, non contiene
 * marchi: e' una scelta della libreria, non una mancanza. Un marchio non
 * e' un'icona generica - cambia forma quando l'azienda lo cambia, e chi
 * lo disegna deve restare fedele a quella forma.
 *
 * Accetta `size` e `color` come le icone di Lucide, cosi' la barra puo'
 * trattarla come tutte le altre senza sapere che e' diversa.
 */

export default function IconaWhatsApp({ size = 24, color = 'currentColor', ...resto }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            aria-hidden="true"
            focusable="false"
            {...resto}
        >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
            <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a12 12 0 0 0 5.71 1.447h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.495-8.411M12.05 21.785h-.004a9.9 9.9 0 0 1-5.031-1.37l-.36-.214-3.741.975 1-3.62-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.002-5.45 4.457-9.885 9.942-9.885a9.87 9.87 0 0 1 7.022 2.9 9.79 9.79 0 0 1 2.909 6.994c-.003 5.45-4.458 9.885-9.942 9.885" />
        </svg>
    );
}
